<template>
  <div style="padding: 10px 14px; font-family: Arial, sans-serif">
    <h3>Disclaimer</h3>
    <p>
      Dear User, in order to use the {{ activationCompany.abbreviation }} Teaching Cube service, please read this Disclaimer carefully and fully understand the content of each
      clause. Unless you have thoroughly read, completely understood, and accepted all terms of this agreement, do not purchase this service.
      <strong>
        <u>
          By clicking "Agree", "Next", or any other action indicating your acceptance of this agreement, whether explicitly or implicitly, you are deemed to have read and
          agreed to be bound by this agreement, making it a legally binding document for both parties.
        </u>
      </strong>
    </p>
    <p>
      1. The User agrees and understands that we will make reasonable commercial efforts to ensure the security of your data storage in this software service, but we cannot
      provide complete guarantees, including but not limited to:
    </p>
    <p>(1) We are not responsible for the deletion or storage failure of relevant data in this software service;</p>
    <p>
      (2) We have the right to determine the maximum storage period of your data in this software according to actual conditions and legal requirements. You can back up
      related data within this storage space as needed. However, due to limitations on storage space or technical reasons, device and network environment factors, etc., some
      data may not be saved entirely, lost, or erroneous, and we shall not be liable for such situations;
    </p>
    <p>
      (3) If you stop using the software functions and services or if the service is terminated or canceled, we will delete your data from the server. Unless required by
      applicable laws and regulations, we have no obligation to return any data after the termination, cancellation, or suspension of the service.
    </p>
    <p>Given the special nature of network services, we are not liable for the following actions taken based on our business strategy and user experience:</p>
    <p>(1) You agree that we can change, interrupt, or stop part or all of this service at any time;</p>
    <p>
      (2) We have the right to regularly or irregularly inspect or maintain the platform providing this service or related equipment. If such circumstances cause interruptions
      or suspensions of this service within a reasonable time frame, we are not liable for any responsibility;
    </p>
    <p>
      (3) Due to changes in business strategies or adjustments, users in different regions may have access to different specific contents of this software service. Specific
      details will be provided by us. For this reason, we assume no liability.
    </p>
    <p>
      2. Since we cannot guarantee the accuracy of the data loaded from the data source or the continuous smoothness of the data receiving channel, we cannot guarantee the
      continuity, timeliness, and accuracy of the related services provided. If you find inaccuracies, errors, omissions, or other issues with the data received and updated by
      us, please contact us or verify with the data source where your information resides promptly.
    </p>
    <p>
      3. This software does not contain any malicious code intended to destroy your computer data or obtain your personal information. This software has undergone detailed
      testing, but it cannot guarantee compatibility with all hardware and software systems and cannot guarantee that there are no software errors. In case of incompatibility
      or software errors, you can call our technical support hotline to report the issue and receive assistance. If the compatibility problem cannot be resolved, you can
      uninstall this software.
    </p>
    <p>
      4. To the fullest extent allowed by applicable law, we are not liable for any damages or risks resulting from the use or inability to use this software, including but
      not limited to direct or indirect personal damage, loss of business profits, interruption of trade, loss of business information, or any other economic losses.
    </p>
    <p>
      5. If you violate this agreement and cause damage to us, we have the right to take measures including but not limited to terminating the usage license, stopping service
      provision, restricting usage, and pursuing legal action.
    </p>
    <p>
      6. If you are complained about by others or complain about others, we have the right to provide necessary information such as the identities and contact details of the
      parties involved and the content of the complaint to the relevant parties or departments to resolve complaints promptly and protect the legitimate rights and interests
      of all parties.
    </p>
    <p>7. We are not liable for the inability to provide normal service due to the following reasons:</p>
    <p>(1) During maintenance downtime of the system hosting this service;</p>
    <p>(2) Faults in your computer, mobile phone hardware and software, communication lines, and power supply lines;</p>
    <p>(3) Improper operation by you or use of this software service through unauthorized or unapproved means;</p>
    <p>(4) Risks caused by unstable network signals leading to login failures or incomplete data synchronization;</p>
    <p>
      (5) Reasons such as virus attacks, malware, malicious programs, network congestion, system instability, system or device malfunctions, communication failures, power
      outages, or government actions;
    </p>
    <p>
      (6) Interruptions or delays in this software service caused by hacker attacks, technical adjustments or faults by network providers, website upgrades, system-related
      issues, etc.;
    </p>
    <p>(7) Risks of service interruptions or stops caused by technical adjustments by telecommunications departments;</p>
    <p>(8) Risks of temporary closures of this service due to government regulation;</p>
    <p>Despite the above provisions, we will take reasonable actions to actively restore service operations.</p>
    <p>8. We are not liable for any service system obstacles preventing the execution of business due to the following force majeure events:</p>
    <p>
      (1) You understand and agree that during the use of this service, you may encounter risk factors such as force majeure, which may affect this service. Force majeure
      refers to objective events that cannot be foreseen, overcome, or avoided and have significant impacts on one or both parties, including but not limited to natural
      disasters like floods, earthquakes, epidemics, and storms, as well as social events like wars, riots, government actions, and pandemics. When such situations occur, we
      will strive to cooperate with relevant units as soon as possible to address them, but we are exempt from liability for any losses you incur within the scope allowed by
      law.
    </p>
    <p>
      (2) You understand and agree that as an internet software, this software may be affected by various factors, including but not limited to user behavior, network service
      quality, and social environments; it may also be subject to various security threats, including but not limited to illegal use of user information for harassment in real
      life; other software downloaded and installed by users or websites visited may contain viruses, malware, or other malicious programs, posing threats to the security of
      your terminal device information and data, thereby affecting the normal use of this software. Therefore, you should enhance your awareness of information security and
      protection of personal information, pay attention to password protection, and avoid losses.
    </p>
    <p>
      9. You understand and agree that during the use of this service, you may encounter risks brought about by online information or the behavior of other users. We are not
      responsible for the authenticity, applicability, or legality of any information nor for any damages caused by infringement. These risks include but are not limited to:
    </p>
    <p>(1) Information containing threats, defamation, offensive, or illegal content from anonymous or impersonated individuals;</p>
    <p>(2) Psychological, physical harm, and economic losses suffered from misleading, deceptive, or other actions causing or potentially causing such harms;</p>
    <p>(3) Other risks arising from online information or user behavior.</p>
    <p>
      10. Under any circumstances, you should not easily believe loan offers, requests for passwords, or other property-related information. For transactions involving assets,
      always verify the identity of the other party first and frequently note our anti-fraud crime prevention tips.
    </p>
    <p>Company: {{ activationCompany.company }}</p>
    <p>Tel: 400-632-8880</p>
    <p>Contact Person: Customer Service Specialist</p>
    <p>Address: {{ activationCompany.address }}</p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Andao Photoelectric Material Manufacturing Co., Ltd.',
        address: 'Building A, Block 11, Zone C, International Financial Park, Songshan Lake District, Dongguan City, Guangdong Province',
        abbreviation: 'Andao'
      }
    }
  },
  created() {
    this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style scoped>
p {
  line-height: 1.6;
  margin-bottom: 10px;
}

strong u {
  color: #ff0000;
}

ul {
  list-style-type: decimal;
  padding-left: 20px;
}

li {
  margin-bottom: 5px;
}
</style>
